<template>
  <div class="page-search">
    <div>
    <div class="pages" v-if="results.rows.length > 0">
      <div v-for="page in results.rows" class="page-entry" :key="page.id" itemscope itemtype="https://schema.org/WebPage">
        <a :href="page.url" class="page-image" :style="{backgroundImage: 'url(' + page.imageUrl +')'}" itemprop="url" :title="page.title">
        </a>
        <div class="page-details">
            <div>
                <div class="page-title" style="word-wrap: break-word;" itemprop="name" @click="onItemClicked(page)">{{page.title}}</div>
                <div class="page-subtitle" style="word-wrap: break-word;" itemprop="subjectOf" @click="onItemClicked(page)">{{page.subtitle}}</div>
                <div class="page-description" style="word-wrap: break-word;"><span v-html="page.description" itemprop="description" @click="onItemClicked(page)"></span>&nbsp; 
                <a class="morelink" style="display: inline;" :href="page.url" :title="page.title">{{labels.more}}</a></div>
            </div>
        </div>
      </div>
      <Pager :total-items="results.totalRows" :current-items="results.rows.length" @click="onShowMore"></Pager>
    </div>
    <div class="no-items" v-if="results.rows.length == 0 && !isLoading">{{labels.noItemsFound}}</div>
    <div class="searchrefinersbox" style="display: block;" v-if="results.rows.length > 0 && results.facets.length > 0">
      <h2>{{labels.filterTitle}}</h2>
      <Facet v-for="facet in results.facets" :key="facet.name" :collapsed="isCollapsed(facet)" :label="facet.name" :facet-id="'pages_'+facet.name" v-if="hiddenFacets.indexOf(facet.name) === -1">
          <FacetOption v-for="opt in facet.options" :label="opt.name" :value="facet.id+'='+opt.id" :count="opt.count" :key="opt.id" :on-change="onFacetOptionChecked" :checked="isFacetOptionChecked(facet.id+'='+opt.id)">
          </FacetOption>
      </Facet>
    </div>
    </div>
    <div class="please-wait" v-if="isLoading">
      <img src="/images/pic_loading.gif" />
    </div>
  </div>
</template>

<script>
import 'es6-promise/auto'
import { Bus } from './services/bus.js'
import { Labels } from './services/labels.js'
import { Settings } from './services/settings.js'
import { Utils } from './services/utils.js'
import Facet from './ui/Facet.vue'
import FacetOption from './ui/FacetOption.vue'
import Pager from './ui/Pager.vue'
import axios from 'axios'
import { SessionState } from './services/session-state.js'

export default {
  name: 'PageSearch',
  components: {
    Facet,
    FacetOption,
    Pager
  },
  props: {
    resultCount: String
  },
  data () {
    return {
      labels: Labels,
      isLoading: false,
      currentQuery: "",
      results: {
        rows: [],
        facets: []
      },
      tags: "",
      collapsedFacets: Settings.pages.collapsedFacets,
      selectedFacetOptions:[],
      isFirstQuery:true,
      hiddenFacets: Settings.hiddenFacets
    }
  },
  created() {
    Bus.$on("start-search", this.search)
  },
  beforeDestroy() {
    Bus.$off('start-search');
  },
  mounted() {
    var facetOpts = SessionState.get("pages", "facets");
    if (facetOpts) {
      this.selectedFacetOptions = JSON.parse(facetOpts);
    }    
  },
  methods: {
    onItemClicked(item) {
      if (!item) return;
      window.open(item.url, "_self");
    },
    isCollapsed(facet) {
      if (this.collapsedFacets.indexOf(facet.name) != -1) return true;
      else return false;
    },
    search (filters, fromWithin) {
      var oThis = this;
      oThis.currentQuery = filters.query;
      oThis.tags = filters.tags;
      if (!fromWithin && !this.isFirstQuery) {
        this.selectedFacetOptions = [];
        SessionState.set("pages", "facets", null);
      }
      this.isFirstQuery = false;
      console.log("Searching for pages with " + filters.query)
      oThis.isLoading = true;
      var url = Utils.constructNewQueryUrl("pages", filters.query, this.selectedFacetOptions);
      axios.get(url).then(function (response) {
        oThis.results = Utils.processSearchResults(response, oThis.results);
        if (oThis.tags.length > 0) {
          oThis.selectTagsInFacets();
        }
        oThis.$emit("input", oThis.results.totalRows);
        Utils.applyVisualUpdates(".page-search");
        oThis.isLoading = false;
        if (!fromWithin) {//we only report to analytics search queries, not results refining
          Utils.reportResultsToAnalytics("Page Search", filters.query, oThis.results.totalRows);
        }
      }).catch(function (err) {
          console.error("Error loading pages: " + err.message);
          oThis.results = {rows: [], facets: []};
          oThis.$emit("input", oThis.results.totalRows);
          oThis.isLoading = false;
        });
      
    },
    onShowMore() {
      var oThis = this;
      console.log("Searching for more pages with " + this.currentQuery)
      oThis.isLoading = true;
      var url = Utils.constructQueryUrl("pages", this.currentQuery, oThis.results, this.selectedFacetOptions);
      axios.get(url).then(function (response) {
        oThis.results = Utils.processSearchResults(response, oThis.results, true);
        Utils.applyVisualUpdates(".page-search");
        oThis.isLoading = false;
      }).catch(function (err) {
          console.error("Error loading pages: " + err.message);
          oThis.results = {rows: [], facets: []};
          oThis.isLoading = false;
        });
    },
    onFacetOptionChecked(opt) {
      if (!opt) return;
      this.selectedFacetOptions = Utils.processFacetChecked(this.selectedFacetOptions, opt);
      this.search({query: this.currentQuery, tags:""}, true);  
      SessionState.set("pages", "facets", JSON.stringify(this.selectedFacetOptions));
    },
    isFacetOptionChecked(val) {
      return (this.selectedFacetOptions.indexOf(val) != -1);
    },
    selectTagsInFacets() {
      if (!this.tags || this.tags.length == 0) return;
      if (this.results.facets.length == 0) return;
      var oThis = this;
      var bMustReload = false;
      var tags = oThis.tags.split(',');
      this.results.facets.forEach(function (facet) {
        facet.options.forEach(function (opt) {
          if (tags.indexOf(opt.id) != -1) {
            oThis.selectedFacetOptions.push(facet.id+"="+opt.id);
            var pos = oThis.collapsedFacets.indexOf(facet.name);
            if (pos != -1) oThis.collapsedFacets.splice(pos, 1);  //we expand the category automatically
            bMustReload = true;
          }
        });
      });
      if (bMustReload) {
        this.search({query: this.currentQuery, tags:""}, true);
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.please-wait {
  display: flex;
  width:100%;
  justify-content: center;
}

.page-search > div {
  display: flex;
  flex-direction: row;
}

.page-search .pages {
  width: calc(100% - 330px);
}

.pages .page-entry {
    display: flex;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom:1px dotted #DDDDDD;
}

.pages .page-entry .page-image {
    width: 64px;
    height: 64px;
    border-radius: 5px;
    background-size: cover;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    min-width: 64px;
}

.pages .page-entry .page-details {
    margin-left: 10px;
    color: #323232;
    cursor: pointer;
}

.pages .page-entry .page-details div.page-title {
    font-family: "Gotham SSm A", Arial, Helvetica, sans-serif;
    font-weight: 700;
}

.pages .page-entry .page-details .page-subtitle {
    font-family: "Gotham SSm A";
    font-size: 14px;
    text-transform: uppercase;
    font-weight: 500;
}

.pages .page-entry .page-details .page-description {
    font-family: "Gotham Narrow", Arial, Helvetica, sans-serif;
    font-size: 15px;
}

.pages .page-entry .morelink { 
	display: inline-block;
	padding-top: 1px;
	padding-left: 10px;
	font-family: 'Gotham SSm A', 'Gotham SSm B', sans-serif;
	font-weight: 500;
	font-size: 12px;
	line-height: inherit;
	text-transform: uppercase;
	background-image: url('../assets/bullet-arrow-blue.png');
	background-repeat: no-repeat;
	background-size: 6px 9px;
    background-position: 0px 4px;
    color:#2655FF;
}

.searchrefinersbox {
  width: 300px;
  max-width: 300px;
  min-width: 300px;
  margin-left: 30px;
  margin-bottom: 40px;
}

.searchrefinersbox > H2 {
  padding-top: 2px;
  padding-bottom: 14px;
    font-family: 'Gotham SSm A', sans-serif;
    font-size: 20px;
    line-height: 24px;
    font-weight: 700;
    font-style: normal;
    text-transform: uppercase;
    border-bottom: 1px solid #e4e4e4;
}

@media all and (max-width: 780px) {
.page-search > div {
  flex-wrap: wrap-reverse;
}

.page-search .pages {
  width: 100%;
}

.searchrefinersbox {
  width: 100%;
  margin-left: 0;
  max-width: 100%;
  min-width: 100%;
}


}
</style>
